import { styled, TextField } from '@mui/material';
import { companyOpcoFundingType, fundingType } from '../../types';

function CompanyDetails(props: {
    funding: companyOpcoFundingType;
    setFunding: (funding: fundingType) => void;
}): JSX.Element {
    const { funding, setFunding } = props;
    return (
        <CompanyInfosContainer>
            <CompanyInfoContainer>
                <TextField
                    fullWidth
                    required
                    autoFocus
                    value={funding.company}
                    label="Nom de l'entreprise"
                    onChange={(event) => setFunding({ ...funding, company: event.target.value })}
                />
            </CompanyInfoContainer>
            <CompanyInfoContainer>
                <TextField
                    fullWidth
                    required
                    value={funding.siret}
                    label="N° de SIRET"
                    onChange={(event) => setFunding({ ...funding, siret: event.target.value })}
                />
            </CompanyInfoContainer>
            <CompanyInfoContainer>
                <TextField
                    fullWidth
                    required
                    value={funding.address}
                    label="Adresse de l'entreprise"
                    onChange={(event) => setFunding({ ...funding, address: event.target.value })}
                />
            </CompanyInfoContainer>
            <CompanyInfoContainer>
                <TextField
                    fullWidth
                    required
                    value={funding.managementName}
                    label="Prénom et NOM du/de la référent·e (direction)"
                    onChange={(event) =>
                        setFunding({
                            ...funding,
                            managementName: event.target.value,
                        })
                    }
                />
            </CompanyInfoContainer>
            <CompanyInfoContainer>
                <TextField
                    fullWidth
                    type="email"
                    required
                    value={funding.managementEmail}
                    label="Adresse mail de la direction"
                    onChange={(event) =>
                        setFunding({
                            ...funding,
                            managementEmail: event.target.value,
                        })
                    }
                />
            </CompanyInfoContainer>
        </CompanyInfosContainer>
    );
}

const CompanyInfoContainer = styled('div')(({ theme }) => ({
    display: 'flex',
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    width: '100%',
}));
const CompanyInfosContainer = styled('div')(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
}));

export { CompanyDetails };
